import React from "react";
import { Pressable, Text, View } from "react-native";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import { useTheme } from "../../../theme";
import styles from "../TicketDetailScreenStyles";

type Props = {
  ticketId: string;
  /** Label shown in the breadcrumb middle segment (e.g. "My Tickets", "Sustain Queue") */
  sourceScreen?: string;
  onBackToSource: () => void;
  onBackToPortal: () => void;
  onCopyLink: () => void;
  onReopen?: () => void;
};

const TicketDetailHeader: React.FC<Props> = ({
  ticketId,
  sourceScreen = "My Tickets",
  onBackToSource,
  onBackToPortal,
  onCopyLink,
  onReopen,
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return (
    <View style={[styles.pageHeader, isDark && { backgroundColor: colors.background.page, borderBottomColor: colors.border.divider }]}>
      <View style={styles.pageTitleBlock}>
        <View style={styles.breadcrumb}>
          <Pressable onPress={onBackToPortal}>
            <Text style={[styles.breadcrumbLink, isDark && { color: colors.brand?.primary ?? "#3D8BFF" }]}>Ticketing Portal</Text>
          </Pressable>
          <Text style={[styles.breadcrumbSep, isDark && { color: colors.text.secondary }]}>/</Text>
          <Pressable onPress={onBackToSource}>
            <Text style={[styles.breadcrumbLink, isDark && { color: colors.brand?.primary ?? "#3D8BFF" }]}>{sourceScreen}</Text>
          </Pressable>
          <Text style={[styles.breadcrumbSep, isDark && { color: colors.text.secondary }]}>/</Text>
          <Text style={[styles.breadcrumbCurrent, isDark && { color: colors.text.secondary }]}>{ticketId}</Text>
        </View>
      </View>

      <View style={styles.pageActions}>
        {onReopen ? (
          <Pressable
            style={({ pressed }: { pressed: boolean }) => [
              styles.btnPrimary,
              { backgroundColor: "#16a34a" },
              pressed && styles.btnPressed,
            ]}
            onPress={onReopen}
          >
            <MaterialIcons name="refresh" size={14} color="#ffffff" />
            <Text style={styles.btnPrimaryText}>Re-Open Ticket</Text>
          </Pressable>
        ) : null}

        <Pressable
          style={({ pressed }: { pressed: boolean }) => [styles.btnGhost, isDark && { backgroundColor: "#2B2B2B", borderColor: "#404040" }, pressed && styles.btnPressed]}
          onPress={onBackToSource}
        >
          <MaterialIcons name="chevron-left" size={16} color={isDark ? "#B0B0B0" : "#374151"} />
          <Text style={[styles.btnGhostText, isDark && { color: "#B0B0B0" }]}>Back</Text>
        </Pressable>

        <Pressable
          style={({ pressed }: { pressed: boolean }) => [styles.btnSecondary, isDark && { backgroundColor: "#2B2B2B", borderColor: "#404040" }, pressed && styles.btnPressed]}
          onPress={onCopyLink}
        >
          <MaterialIcons name="link" size={14} color={isDark ? "#B0B0B0" : "#374151"} />
          <Text style={[styles.btnSecondaryText, isDark && { color: "#B0B0B0" }]}>Copy Link</Text>
        </Pressable>
      </View>
    </View>
  );
};

export default TicketDetailHeader;
